/**
 * Curated city → landmark photo mapping for the dashboard "City Highlight" cards.
 * Uses Unsplash hotlinks with size + crop params (free for commercial use, see Unsplash license).
 * Fallback used for any city not in the mapping.
 */

// Unsplash photo IDs (curated for Indian cities / generic Indian landscapes).
const CITY_IMAGES = {
  // Bihar
  "gaya":          "https://images.unsplash.com/photo-1573398643956-2b9e6ade3456?w=400&h=240&fit=crop&q=70",      // Mahabodhi temple / Buddha
  "patna":         "https://images.unsplash.com/photo-1623688947902-3f0e25cba83a?w=400&h=240&fit=crop&q=70",      // Patna Ganga
  "muzaffarpur":   "https://images.unsplash.com/photo-1602940659805-770d1b3b9911?w=400&h=240&fit=crop&q=70",      // Litchi grove
  "khagaria":      "https://images.unsplash.com/photo-1605640840605-14ac1855827b?w=400&h=240&fit=crop&q=70",      // River bridge
  "bhagalpur":     "https://images.unsplash.com/photo-1623688947902-3f0e25cba83a?w=400&h=240&fit=crop&q=70",      // river
  "purnia":        "https://images.unsplash.com/photo-1583395852019-9f1f1f2c1226?w=400&h=240&fit=crop&q=70",      // rural Bihar
  "darbhanga":     "https://images.unsplash.com/photo-1605640840605-14ac1855827b?w=400&h=240&fit=crop&q=70",
  "saharsa":       "https://images.unsplash.com/photo-1583395852019-9f1f1f2c1226?w=400&h=240&fit=crop&q=70",
  // Jharkhand
  "pakur":         "https://images.unsplash.com/photo-1602941526413-15c92ed6041e?w=400&h=240&fit=crop&q=70",      // hills
  "ranchi":        "https://images.unsplash.com/photo-1568010967792-3d8da7be4d35?w=400&h=240&fit=crop&q=70",      // hills
  "dhanbad":       "https://images.unsplash.com/photo-1568010967792-3d8da7be4d35?w=400&h=240&fit=crop&q=70",
  "jamshedpur":    "https://images.unsplash.com/photo-1568010967792-3d8da7be4d35?w=400&h=240&fit=crop&q=70",
  // Odisha
  "kendrapara":    "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=240&fit=crop&q=70",      // temple
  "bhubaneswar":   "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=240&fit=crop&q=70",      // temple
  "puri":          "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=240&fit=crop&q=70",
  "cuttack":       "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=240&fit=crop&q=70",
  // West Bengal
  "kolkata":       "https://images.unsplash.com/photo-1558431382-27e303142255?w=400&h=240&fit=crop&q=70",         // Howrah Bridge
  "siliguri":      "https://images.unsplash.com/photo-1605640840605-14ac1855827b?w=400&h=240&fit=crop&q=70",
  // UP
  "lucknow":       "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=240&fit=crop&q=70",
  "varanasi":      "https://images.unsplash.com/photo-1561361398-a87a3a52ab97?w=400&h=240&fit=crop&q=70",         // ghats
  "agra":          "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=400&h=240&fit=crop&q=70",      // Taj Mahal
  "noida":         "https://images.unsplash.com/photo-1567527595576-0e1cf26b2ecd?w=400&h=240&fit=crop&q=70",      // skyline
  // Maharashtra
  "mumbai":        "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=400&h=240&fit=crop&q=70",      // Gateway of India
  "pune":          "https://images.unsplash.com/photo-1567527595576-0e1cf26b2ecd?w=400&h=240&fit=crop&q=70",
  // Delhi/Haryana
  "delhi":         "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=400&h=240&fit=crop&q=70",      // India Gate
  "new delhi":     "https://images.unsplash.com/photo-1587474260584-136574528ed5?w=400&h=240&fit=crop&q=70",
  "gurugram":      "https://images.unsplash.com/photo-1567527595576-0e1cf26b2ecd?w=400&h=240&fit=crop&q=70",
  "faridabad":     "https://images.unsplash.com/photo-1567527595576-0e1cf26b2ecd?w=400&h=240&fit=crop&q=70",
  // Karnataka / Telangana / TN
  "bengaluru":     "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=400&h=240&fit=crop&q=70",
  "bangalore":     "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=400&h=240&fit=crop&q=70",
  "hyderabad":     "https://images.unsplash.com/photo-1572295591318-7c3d51c00d12?w=400&h=240&fit=crop&q=70",      // Charminar
  "chennai":       "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=240&fit=crop&q=70",
  "tirupati":      "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=240&fit=crop&q=70",
  // Gujarat / Rajasthan
  "ahmedabad":     "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=400&h=240&fit=crop&q=70",
  "surat":         "https://images.unsplash.com/photo-1564507592333-c60657eea523?w=400&h=240&fit=crop&q=70",
  "jaipur":        "https://images.unsplash.com/photo-1599661046289-e31897846e41?w=400&h=240&fit=crop&q=70",      // Hawa Mahal
};

const FALLBACK = "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=400&h=240&fit=crop&q=70"; // generic Indian temple landscape

export function imageForCity(city) {
  if (!city) return FALLBACK;
  const k = city.toString().trim().toLowerCase();
  return CITY_IMAGES[k] || FALLBACK;
}
